import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FileSpreadsheet, Loader2 } from 'lucide-react';
import { userLedger, creditorLedger } from './reconApi';
import { exportLedgerExcel } from '../../utils/exportLedgerExcel';

/**
 * Download one party's account as the workbook an accountant expects.
 *
 * A customer's ledger and a creditor's are the same two columns with the debt
 * pointing opposite ways, so one button serves both and `kind` says which.
 */
const LedgerButton = ({ kind = 'customer', id, name, className = '' }) => {
  const [busy, setBusy] = useState(false);

  const download = async (e) => {
    e.stopPropagation();
    if (!id) { toast.error('This row has nobody to draw a ledger for'); return; }
    setBusy(true);
    const t = toast.loading(`Building ${name || 'the'} ledger…`);
    try {
      const ledger = kind === 'creditor' ? await creditorLedger(id) : await userLedger(id);
      if (!ledger.entries.length) {
        toast(`Nothing on ${name || 'this'} account yet`, { id: t, icon: 'ℹ️' });
        return;
      }
      await exportLedgerExcel({ partyName: name, kind, ...ledger });
      toast.success(`${ledger.entries.length} entries downloaded`, { id: t });
    } catch (err) {
      toast.error(err.message || 'Could not build the ledger', { id: t });
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={download}
      disabled={busy}
      title={`Download ${name || 'this party'}'s ledger`}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-lg text-[12px] font-bold
                  whitespace-nowrap transition disabled:opacity-50
                  text-blue-700 bg-blue-50 hover:bg-blue-100
                  dark:text-blue-300 dark:bg-blue-500/15 dark:hover:bg-blue-500/25 ${className}`}
    >
      {busy ? <Loader2 size={13} className="animate-spin" /> : <FileSpreadsheet size={13} />} Ledger
    </button>
  );
};

export default LedgerButton;
